module.exports = __webpack_public_path__ + "img/numbersOrdered.04ad5dec.svg";